<template>
  <div class="col_box" @click="handleClick()">
    <div class="col_item" :class="{docpadding: docFirst === 0}">
      <div :class="{part1: collect.picType == 0,part3:collect.picType != 0}">
        <!-- 大图 -->
        <div class="bigImg" v-if="collect.picType == 1" :style="{backgroundImage: 'url('+ collect.picUrlList[0] + useImageParam(collect.picUrlList[0], 5, 670, 376) + ')',opacity: collect.ifAlive == false ? '0.45' : '1'}">
          <div v-show="collect.ifAlive == false" class="xiajiabig">已下架</div>
        </div>
        <!-- 3图 -->
        <div class="threeImg" v-if="collect.picType == 2">
          <div
            class="three-img"
            v-for="(item,index) in collect.picUrlList"
            :key="index"
            :style="{backgroundImage: 'url('+ item + useImageParam(item, 5, 212, 160) + ')',opacity: collect.ifAlive == false ? '0.45' : '1'}"
          >
            <div v-show="collect.ifAlive == false" class="xiajiathree">已下架</div>
          </div>
        </div>
        <div class="part1a" v-if="collect.picType == 0" v-html="collect.title" :style="{ opacity: collect.ifAlive == false ? '0.45' : '1' }"></div>
        <div class="part1awidth" v-if="collect.picType != 0" v-html="collect.title" :style="{ opacity: collect.ifAlive == false ? '0.45' : '1' }"></div>
        <router-link class="SeoSp" :to="SeoLink?SeoLink:changeUrlSeo()">{{collect.title}}</router-link> 
        <div class="part1b" v-if="collect.doctorBaseInfoDto && collect.doctorBaseInfoDto.userName && collect.doctorBaseInfoDto.hospitalName && collect.doctorBaseInfoDto.medTitleName">
          <span>{{ collect.doctorBaseInfoDto.userName }}</span>
          <span>|</span>
          <span>{{ collect.doctorBaseInfoDto.hospitalName }}</span>
          <span>|</span>
          <span>{{ collect.doctorBaseInfoDto.medTitleName }}</span>
        </div>
        <div class="part1c" v-show="true" :style="{ opacity: collect.ifAlive == false ? '0.45' : '1' }">
          <!-- <span class="kong">{{ collect.readAmount }}人观看</span> -->
          <span class="kong" v-if="!hideTime">{{ releaseTime }}</span>
        </div>
        
      </div>
      <div class="part2" v-if="collect.picType == 0">
        <div class="collectImg" :style="{backgroundImage: 'url('+ collect.picUrlList[0] + useImageParam(collect.picUrlList[0], 5, 212, 160) + ')',opacity: collect.ifAlive == false ? '0.45' : '1'}"></div>
        <img :src="$store.state.app.qiniuHostUrl + 'play_a2.png'" v-show="collect.docType == 6 || collect.docType == 24" class="play_btn" alt="" :style="{ opacity: collect.ifAlive == false ? '0.45' : '1' }"/>
        <div v-show="collect.ifAlive == false" class="xiajia">已下架</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useImageParam } from '@/assets/js/utils'
export default {
  name: 'Collect',
  data() {
    return {
      useImageParam: useImageParam
    }
  },
  props: {
    collect: Object,
    isShowRead: Boolean,
    hideTime: Boolean,
    SeoLink:String,
    docFirst:Number
  },
  methods: {
    handleClick() {
      this.$emit('tap', this.collect)
    },
    changeUrlSeo(){
      return ''
    }
  },
  computed: {
    releaseTime() {
      var year, month, date
      if(new Date(this.collect.releaseTime*1000).getDate() === new Date().getDate() 
      && new Date(this.collect.releaseTime*1000).getFullYear() === new Date().getFullYear() 
      && new Date(this.collect.releaseTime*1000).getMonth() === new Date().getMonth()) {
        return "今日"
      } else if(new Date(this.collect.releaseTime*1000).getFullYear() === new Date().getFullYear()){
        // var year = new Date(this.collect.releaseTime*1000).getFullYear()
        month = new Date(this.collect.releaseTime*1000).getMonth() + 1
        date = new Date(this.collect.releaseTime*1000).getDate()
        return month + '月' + date + '日'
      } else {
        year = new Date(this.collect.releaseTime*1000).getFullYear()
        month = new Date(this.collect.releaseTime*1000).getMonth() + 1
        date = new Date(this.collect.releaseTime*1000).getDate()
        return year + '年' + month + '月' + date + '日'
      }
    },
    picurl() {
      if(this.collect.picurl.indexOf('demoqiniu.hjbxjz.com') == -1 && this.collect.picurl.indexOf('qiniu.hjbxjz.com') == -1) {
        return this.collect.picurl
      } else {
        return this.collect.picurl + useImageParam(this.collect.picurl, 5, 318, 240)
      }
    }
  }
}
</script>
<style scoped>
div {
  box-sizing: border-box;
}
.col_box {
  width: 100vw;
  height: auto;
  overflow: hidden;
}
.col_item {
  width: 100%;
  height: auto;
  padding: 14px 20px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}
.docpadding {
  padding: 0 20px 14px 20px;
}
.part1 {
  width: 213px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.part3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.part1a {
  line-height: 24px;
  color: #454556;
  font-size: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
}
.part1awidth {
  width: 100%;
  line-height: 24px;
  color: #454556;
  font-size: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
  overflow: hidden;
}
.bigImg {
  position: relative;
  width: calc(100vw - 40px);
  height: calc((100vw - 40px) * 188 / 335);
  border-radius: 6px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 8px;
}
.xiajiabig {
  position: absolute;
  top: calc(50% - 12px);
  left: calc(50% - 33px);
  color: #fff;
  background-color: #9890A1;
  border-radius: 16px;
  width: 65px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.threeImg {
  width: calc(100vw - 40px);
  height: calc((100vw - 40px) * 80 / 335);
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.three-img {
  position: relative;
  width: calc((100vw - 58px) / 3);
  height: calc((100vw - 40px) * 80 / 335);
  background-size: 100% auto;
  border-radius: 4px;
  /* object-fit: contain; */

}
.three-img .xiajiathree {
  position: absolute;
  top: calc(50% - 12px);
  left: calc(50% - 33px);
  color: #fff;
  background-color: #9890A1;
  border-radius: 16px;
  width: 65px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.part1b {
  width: 208px;
  line-height: 20px;
  color: #9696ab;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* .part1b span {
  display: inline-block;
} */
.part1b span:nth-child(n + 2) {
  margin-left: 5px;
}
.part1c {
  font-size: 11px;
  color: #cacad8;
}
.part2 {
  width: 28.26vw;
  height: 21.33vw;
  border-radius: 4px;
  /* background-size: cover !important; */
  position: relative;
}
.collectImg {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  border-radius: 4px;
  object-fit: contain;
}
.part2 .play_btn {
  display: flex;
  width: 22px;
  height: 22px;
  position: absolute;
  /* right: 4px;
  bottom: 4px; */
  top: 100%;
  left: 100%;
  margin-top: -26px;
  margin-left: -26px;
}
.xiajia {
  /* background:rgba(255,255,255,1); */
  color: #fff;
  background-color: #9890A1;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  width: 65px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-left: -33px;
  margin-top: -12px;
}

.part1a /deep/ span {
  color: #dd366a;
}
.SeoSp{
  position: absolute;
  z-index: -10;
  color: transparent
}
.kong {
  margin-right: 20px;
}
</style>
